import React from 'react';
import PropTypes from 'prop-types';
import KpiChart from '../../commons/KpiChart';

const LearningReachedLevelRateGauge = (props) => (
  <KpiChart
    title="Reached level rate"
    description={`The percent of students that reached the level of their course in the test. The column "Course progress" shows the average course progress at test execution moment of all students who did the test in the course.`}
    intervals={[0, 50, 80, 100]}
    loading={props.loading}
    currentValue={props.value}
    formatter={props.formatter}
  />
);

LearningReachedLevelRateGauge.propTypes = {
  loading: PropTypes.bool.isRequired,
  value: PropTypes.number.isRequired,
  formatter: PropTypes.func.isRequired,
};

export default LearningReachedLevelRateGauge;
